import { motion } from "framer-motion";
import SectionHeader from "@/components/SectionHeader";

const STEPS = [
  { n: "01", title: "Join Money Printer", desc: "Choose Free or VIP — start wherever you're comfortable.", testid: "step-join" },
  { n: "02", title: "Get Access", desc: "Checkout and membership are handled securely in the background.", testid: "step-access" },
  { n: "03", title: "Receive Picks", desc: "Access picks, analysis and alerts through Money Printer and the member community.", testid: "step-picks" },
  { n: "04", title: "Track Everything", desc: "Follow transparent results and every unit on the public ledger.", testid: "step-track" },
];

export function Steps() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-10 sm:px-6 sm:py-24 lg:px-8" data-testid="how-it-works-section">
      <SectionHeader
        eyebrow="Process"
        title="How It Works"
        sub="From TikTok to tracked ticket in four steps."
        testid="steps-header"
      />
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((s, i) => (
          <motion.div
            key={s.n}
            data-testid={s.testid}
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.4, delay: i * 0.08 }}
            className="card-mp card-hover relative p-6"
          >
            <span className="font-display text-5xl font-black text-[#00E676]/25">{s.n}</span>
            <h3 className="mt-4 font-display text-lg font-bold uppercase tracking-wide text-white">{s.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-slate-400">{s.desc}</p>
            {i < STEPS.length - 1 && (
              <span className="absolute -right-3 top-1/2 hidden h-px w-6 bg-[#2A364F] lg:block" aria-hidden="true" />
            )}
          </motion.div>
        ))}
      </div>
    </section>
  );
}

export default Steps;
